<template>
  <widget-temp :widgetTitle="$t('charts.order_status_title')" widgetName="OrderStatusChart" v-bind:widgetId="4">
    <template slot="widget-content">
      <div class="chart-container">
        <highcharts :options="chartOptions"></highcharts>
      </div>
    </template>
  </widget-temp>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "order-status-chart",
  data() {
    return {};
  },
  computed: {
    ...mapState({
      loading: state => state.dashboard.loading,
      orderData: state => state.dashboard.order_status_chart
    }),
    chartOptions() {
      const colorMap = {
        'Nhập kho TQ': '#f59e0b', // Amber orange
        'Chờ xếp xe': '#3b82f6', // Ocean blue
        'Đã xếp xe': '#10b981', // Emerald green
        'Kiểm hóa': '#f43f5e' // Rose red
      };
      
      const categoryMap = {
        'Nhập kho TQ': this.$t('charts.categories.nhap_kho_tq'),
        'Chờ xếp xe': this.$t('charts.categories.cho_xep_xe'),
        'Đã xếp xe': this.$t('charts.categories.da_xep_xe'),
        'Kiểm hóa': this.$t('charts.categories.kiem_hoa')
      };
      
      const mappedData = this.orderData.map(item => ({
        name: categoryMap[item.name] || item.name,
        y: item.value,
        color: colorMap[item.name] || item.color
      }));

      return {
        chart: {
          type: 'column',
          height: 380,
          style: {
            fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif'
          }
        },
        title: {
          text: ''
        },
        xAxis: {
          categories: mappedData.map(item => item.name),
          crosshair: true,
          labels: {
            style: {
              color: '#64748b',
              fontSize: '12px',
              fontWeight: '500'
            }
          },
          lineColor: '#cbd5e1',
          tickColor: '#cbd5e1'
        },
        yAxis: {
          min: 0,
          title: {
            text: this.$t('charts.order_axis_y'),
            style: {
              color: '#64748b',
              fontSize: '12px',
              fontWeight: '500'
            }
          },
          labels: {
            style: {
              color: '#64748b',
              fontSize: '11px'
            }
          },
          gridLineColor: '#f1f5f9',
          gridLineDashStyle: 'Dash'
        },
        tooltip: {
          backgroundColor: '#ffffff',
          borderWidth: 1,
          borderColor: '#e2e8f0',
          borderRadius: 8,
          shadow: true,
          useHTML: true,
          headerFormat: '<span style="font-size:11px;color:#64748b;font-weight:600;">{point.key}</span><br/>',
          pointFormat: `<span style="color:{point.color}">\u25CF</span> {series.name}: <b>{point.y}</b> ${this.$t('charts.unit_ma_hang')}`,
          shared: true
        },
        plotOptions: {
          column: {
            pointPadding: 0.25,
            borderWidth: 0,
            borderRadius: 6,
            dataLabels: {
              enabled: true,
              format: '{point.y}',
              style: {
                fontSize: '12px',
                fontFamily: 'inherit',
                fontWeight: '600',
                color: '#475569'
              },
              y: -6
            }
          }
        },
        series: [{
          name: this.$t('charts.series_quantity'),
          colorByPoint: true,
          data: mappedData
        }],
        legend: {
          enabled: false
        },
        credits: {
          enabled: false
        }
      };
    }
  },
  watch: {
    orderData: {
      handler() {
        this.$nextTick(() => {
          this.$emit('rendered');
        });
      },
      immediate: true
    }
  },
  methods: {
    async getChartData() {
      this.$store.dispatch("dashboard/getOrderStatusChart");
    }
  },
  mounted() {
    this.getChartData();
  }
};
</script>

<style scoped>
.chart-container {
  padding: 20px;
  min-height: 400px;
}
</style>
